import React from "react";

import { Badge } from "../../../common/components/core";
import { PaymentOrderStatus } from "../../../types/payment";
import { UserRole } from "../../../types/userCurrent";
import { hasPaymentOrderHasAction } from "../../../utils/payment";
import { ApproveStatus } from "../../../types/claim";
import { isUserFinanceDepartment } from "../../../utils/role";

type PaymentOrderStatusBadgeProps = {
    paymentOrderStatus: PaymentOrderStatus;
    roles?: UserRole[];
    showActionRequired?: boolean;
    isPreviousPriorityApproverApproved?: boolean | null;
    approverStatus?: ApproveStatus;
    isListView: boolean;
};

const PreSubmitPaymentStatusBadge = ({
    paymentOrderStatus,
    roles,
    showActionRequired,
    approverStatus,
    isPreviousPriorityApproverApproved,
    isListView,
}: PaymentOrderStatusBadgeProps): JSX.Element => {
    const isFirstApprover = isPreviousPriorityApproverApproved === null;

    switch (paymentOrderStatus) {
        case PaymentOrderStatus.CREATED:
            if (
                showActionRequired &&
                roles &&
                hasPaymentOrderHasAction(
                    roles,
                    paymentOrderStatus,
                    isPreviousPriorityApproverApproved,
                ) &&
                (isFirstApprover || isPreviousPriorityApproverApproved)
            ) {
                return <Badge type="danger">Action Required</Badge>;
            } else {
                return <Badge type="info">Payment Created</Badge>;
            }

        case PaymentOrderStatus.PARTIAL_APPROVED:
            if (
                showActionRequired &&
                roles &&
                hasPaymentOrderHasAction(
                    roles,
                    paymentOrderStatus,
                    isPreviousPriorityApproverApproved,
                ) &&
                approverStatus === ApproveStatus.PENDING &&
                isPreviousPriorityApproverApproved
            ) {
                return <Badge type="danger">Action Required</Badge>;
            }
            return isListView ? (
                <Badge type="success">Payment Submitted</Badge>
            ) : (
                <Badge type="info">Payment Created</Badge>
            );

        case PaymentOrderStatus.REJECTED:
            if (isListView && roles && isUserFinanceDepartment(roles)) {
                return <Badge type="danger">Action Required</Badge>;
            }
            return <Badge type="danger">Payment Rejected</Badge>;
        default:
            return <Badge type="success">Payment Submitted</Badge>;
    }
};

export default PreSubmitPaymentStatusBadge;
